module.exports = __webpack_public_path__ + "static/media/D57D1277-4235-46B0-BB68-5935A7785683.e5979490.JPG";